import axios from 'axios';
export const reportApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
export const formatNumber = value => value == null ? '—' : Number(value).toLocaleString('en-IN', { maximumFractionDigits: 1 });
export const formatPercent = value => value == null ? '—' : `${formatNumber(value)}%`;
export const downloadReport = async (query, metric, version, group = {}) => {
  const params = new URLSearchParams(query);
  Object.entries({ metric, version, ...group }).forEach(([key, value]) => params.set(key, value));
  const { data } = await reportApi.get(`/reporting/export?${params}`, { responseType: 'blob' });
  const url = URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url; link.download = `${metric}.xlsx`; link.click(); URL.revokeObjectURL(url);
};